var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "#",
    d: "M11.0063 14.9989L12.6468 5H14.0138L12.3733 14.9989H11.0063ZM6.5 12.421L6.72947 11.054H14.4239L14.1944 12.421H6.5ZM7.4911 14.9989L9.13153 5H10.4986L8.85813 14.9989H7.4911ZM7.08099 8.94486L7.30557 7.57783H15L14.7754 8.94486H7.08099Z",
    fill: "#2E3438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.caad84e33146458445bcbebe132bef71.svg";
export { ForwardRef as ReactComponent };